import {Route, Routes} from 'react-router-dom';
import DemoApiProductionList from '../pages/demo/productionapi/DemoApiProductionList';
import DemoUploadFile from '../pages/demo/productionapi/DemoUploadFile';
import DemoNumberingSortingView from '../pages/demo/productionapi/DemoNumberingSortingView';
import DemoNumberingSortingSave from '../pages/demo/productionapi/DemoNumberingSortingSave';
import DemoBatesNext from '../pages/demo/productionapi/DemoBatesNext';
import NativeComponentApiTest from '../pages/demo/productionapi/NativeComponentApiTest';
import TextComponentApiTest from '../pages/demo/productionapi/TextComponentApiTest';
import Mp3FileComponentApiTest from '../pages/demo/productionapi/Mp3FileComponentApiTest';
import TranslationComponentApiTest from '../pages/demo/productionapi/TranslationComponentApiTest';
import ProductionComponentsApiTest from '../pages/demo/productionapi/ProductionComponentsApiTest';
import SaveProductionComponentsApiTest from '../pages/demo/productionapi/SaveProductionComponentsApiTest';
import ProductionTemplateApiTest from '../pages/demo/productionapi/ProductionTemplateApiTest';
import DeleteProductionApiTest from '../pages/demo/productionapi/DeleteProductionApiTest';
import DeleteProductionSetApiTest from '../pages/demo/productionapi/DeleteProductionSetApiTest';
import DatComponentView from '../pages/demo/productionapi/DatComponentView';
import DocumentSelectionViewApiTest from '../pages/demo/productionapi/DocumentSelectionViewApiTest';
import SaveDocumentsSelectionApiTest from '../pages/demo/productionapi/SaveDocumentsSelectionApiTest';
import ProductionGuardViewApiTest from '../pages/demo/productionapi/ProductionGuardViewApiTest';
import SaveProductionGuardViewApiTest from '../pages/demo/productionapi/SaveProductionGuardViewApiTest';
import ProductionGuardMatchResultsApiTest from '../pages/demo/productionapi/ProductionGuardMatchResultsApiTest';
import UpdateProductionSetApiTest from '../pages/demo/productionapi/UpdateProductionSetApiTest';
import ProductionSetInfoApiTest from '../pages/demo/productionapi/ProductionSetInfoApiTest';
import DownloadProductionApiTest from '../pages/demo/productionapi/DownloadProductionApiTest';
import NativeErrorListApiTest from '../pages/demo/productionapi/NativeErrorListApiTest';
import ErrorListApiTest from '../pages/demo/productionapi/ErrorListApiTest';
import ErrorExportApiTest from '../pages/demo/productionapi/ErrorExportApiTest';
import ProductLocationViewApiTest from '../pages/demo/productionapi/ProductLocationViewApiTest';
import ValidateDestinationApiTest from '../pages/demo/productionapi/ValidateDestinationApiTest';
import CreateDestinationApiTest from '../pages/demo/productionapi/CreateDestinationApiTest';
import SaveProductionLocationApiTest from '../pages/demo/productionapi/SaveProductionLocationApiTest';
import SummaryViewApiTest from '../pages/demo/productionapi/SummaryViewApiTest';
import SaveSummaryApiTest from '../pages/demo/productionapi/SaveSummaryApiTest';
import GenerateViewApiTest from '../pages/demo/productionapi/GenerateViewApiTest';
import GenerateStatusApiTest from '../pages/demo/productionapi/GenerateStatusApiTest';
import ExportBatesRangeApiTest from '../pages/demo/productionapi/ExportBatesRangeApiTest';
import ExecuteGenerateApiTest from '../pages/demo/productionapi/ExecuteGenerateApiTest';
import ConfirmProductionApiTest from '../pages/demo/productionapi/ConfirmProductionApiTest';
import ShareableLinksApiTest from '../pages/demo/productionapi/ShareableLinksApiTest';
import ConfirmViewApiTest from '../pages/demo/productionapi/ConfirmViewApiTest';
import ProductionPreviewApiTest from '../pages/demo/productionapi/ProductionPreviewApiTest';
import ProductionPreviewFileApiTest from '../pages/demo/productionapi/ProductionPreviewFileApiTest';
import UploadSeedFileApiTest from '../pages/demo/productionapi/UploadSeedFileApiTest';
import ValidateDownloadApiTest from '../pages/demo/productionapi/ValidateDownloadApiTest';
import GetSeedPathApiTest from '../pages/demo/productionapi/GetSeedPathApiTest';
import SeedPageCountApiTest from '../pages/demo/productionapi/SeedPageCountApiTest';

const DemoApiProductionRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<DemoApiProductionList />} />
      <Route path="/dat-component" element={<DatComponentView />} />
      <Route path="/native-component" element={<NativeComponentApiTest />} />
      <Route path="/text-component" element={<TextComponentApiTest />} />
      <Route path="/mp3-file-component" element={<Mp3FileComponentApiTest />} />
      <Route
        path="/translation-component"
        element={<TranslationComponentApiTest />}
      />
      <Route
        path="/production-components"
        element={<ProductionComponentsApiTest />}
      />
      <Route
        path="/save-production-components"
        element={<SaveProductionComponentsApiTest />}
      />
      <Route path="/create-template" element={<ProductionTemplateApiTest />} />
      <Route path="/delete-production" element={<DeleteProductionApiTest />} />
      <Route path="/delete-set" element={<DeleteProductionSetApiTest />} />
      <Route path="/upload-file" element={<DemoUploadFile />} />
      <Route
        path="/numbering-sorting-view"
        element={<DemoNumberingSortingView />}
      />
      <Route
        path="/numbering-sorting-save"
        element={<DemoNumberingSortingSave />}
      />
      <Route path="/bates-next" element={<DemoBatesNext />} />
      <Route
        path="/document-selection-view"
        element={<DocumentSelectionViewApiTest />}
      />
      <Route
        path="/save-documents-selection"
        element={<SaveDocumentsSelectionApiTest />}
      />
      <Route
        path="/production-guard-view"
        element={<ProductionGuardViewApiTest />}
      />
      <Route
        path="/save-production-guard-view"
        element={<SaveProductionGuardViewApiTest />}
      />
      <Route
        path="/production-guard-match-results"
        element={<ProductionGuardMatchResultsApiTest />}
      />
      <Route path="/update-set" element={<UpdateProductionSetApiTest />} />
      <Route
        path="/production-set-info"
        element={<ProductionSetInfoApiTest />}
      />
      <Route
        path="/download-production"
        element={<DownloadProductionApiTest />}
      />
      <Route path="/native-error-list" element={<NativeErrorListApiTest />} />
      <Route path="/error-list" element={<ErrorListApiTest />} />
      <Route path="/error-export" element={<ErrorExportApiTest />} />
      <Route
        path="/product-location-view"
        element={<ProductLocationViewApiTest />}
      />
      <Route
        path="/validate-destination"
        element={<ValidateDestinationApiTest />}
      />
      <Route
        path="/create-destination"
        element={<CreateDestinationApiTest />}
      />
      <Route
        path="/save-production-location"
        element={<SaveProductionLocationApiTest />}
      />
      <Route path="/summary-view" element={<SummaryViewApiTest />} />
      <Route path="/save-summary" element={<SaveSummaryApiTest />} />
      <Route path="/generate-view" element={<GenerateViewApiTest />} />
      <Route path="/generate-status" element={<GenerateStatusApiTest />} />
      <Route path="/export-bates-range" element={<ExportBatesRangeApiTest />} />
      <Route path="/execute-generate" element={<ExecuteGenerateApiTest />} />
      <Route
        path="/confirm-production"
        element={<ConfirmProductionApiTest />}
      />
      <Route path="/shareable-links" element={<ShareableLinksApiTest />} />
      <Route path="/confirm-view" element={<ConfirmViewApiTest />} />
      <Route
        path="/production-preview"
        element={<ProductionPreviewApiTest />}
      />
      <Route
        path="/production-preview-file"
        element={<ProductionPreviewFileApiTest />}
      />
      <Route path="/upload-seed-file" element={<UploadSeedFileApiTest />} />
      <Route path="/validate-download" element={<ValidateDownloadApiTest />} />
      <Route path="/get-seed-path" element={<GetSeedPathApiTest />} />
      <Route path="/seed-page-count" element={<SeedPageCountApiTest />} />
      {/* Add more API test routes here as you create them */}
    </Routes>
  );
};

export default DemoApiProductionRoutes;
